export const NOT_SURE_NICHE_IMG =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ee464c6a3a2f78d29caab151240bfdc8-1750334808201/store_wizard_not_sure_niche.png';

export const NOT_SURE_NICHE = {
    id: 2, // Same id with Electronics & Gadgets
    displayName: "I'm not sure",
    url: NOT_SURE_NICHE_IMG,
};
